<script lang="ts">
  import QR from '@svelte-put/qr/svg/QR.svelte'

  export let value: string = ''
  export let size: number = 100
</script>

{#key value}
  <QR
    data={value}
    width={size}
    height={size}
    margin={0}
    shape="square"
    correction="H"/>
{/key}
